import React from 'react';

import IMGNilza from './../../images/nilza/nilza-menor.png'

const Nilza = () => {
  const handleClick = () => {
    document.location.href = '/admin/nilza'
  };

  return (
    <div className="pl-4 pt-1" style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
      <img
        src={IMGNilza}
        alt=""
        style={{ width: "190px", borderRadius: "10px" }}
        className="cursor-pointer hover:opacity-80 transition"
      />
      <button type="button" onClick={handleClick} style={{ backgroundColor: "#012148", color: "white", width: "190px", height: "35px", border: "0px", borderRadius: "5px", fontWeight: "bold" }}>Fale com a Nilza</button>
    </div>
  );
};

export default Nilza;
